import React from 'react';
import _ from 'lodash';
import FinishShiftCandidate from '../components/FinishShiftCandidate';
import LoadingView from '../components/LoadingView';

import ShiftStore from '../stores/ShiftStore';

import {getTotalCost, updateCandidatePay, getShiftDuration} from '../utils/shiftFees';
import withRouter from '../utils/with-router';

@withRouter
class FinishShiftStep2 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            totalCost: 0,
            ourFee: 0,
            candidatePay: [],
            candidateHours: []
        };
    }

    getCandidates(candidates, duration) {
        let hired_candidates = [];
        for (let i = 0; i < candidates.length; i++) {
            const report = _.filter(this.props.reports, report => {return report.candidate == candidates[i].id})[0];
            const disabled = candidates[i].hiring.no_show || candidates[i].hiring.status == DJ_CONST.HIRING_STATUSES.CANCELLED;
            let hours = duration;
            if (disabled) {
                hours = 0
            } else if (report) {
                hours = parseFloat(report.hours).toFixed(2)
            } else if (candidates[i].hiring.status == DJ_CONST.HIRING_STATUSES.CANCELLED_BY_US) {
                hours = 0
            }
            hired_candidates.push(
                <FinishShiftCandidate index={i} hours={hours} updateCandidatePay={this.updateCandidatePay.bind(this)} candidate={candidates[i]} disabled={disabled} />
            )
        }

        return hired_candidates;
    }

    updateCandidatePay(candidateId, pay, hours, index) {
        const candidates = this.props.candidates.filter(candidate => { return [DJ_CONST.HIRING_STATUSES.CANCELLED_BY_US, DJ_CONST.HIRING_STATUSES.HIRED].indexOf(candidate.hiring.status) >= 0 && !candidate.hiring.no_show });
        const {candidatePay, candidateHours} = updateCandidatePay(candidateId, pay, hours, index, this.state.candidatePay, this.state.candidateHours);
        const {totalCost, ourFee} = getTotalCost(candidatePay, candidates.length);
        this.setState({candidatePay, candidateHours, totalCost, ourFee});
    }

    saveState(shiftId, type) {
        ShiftStore.finishShift(shiftId, this.state.candidateHours, type);
        if (type == 'save') {
            this.context.router.transitionTo('agenda');
        } else {
            this.context.router.transitionTo('shiftclosed', {shiftId});
        }
    }

    getContent() {
        const candidates = this.props.candidates;
        const shift = this.props.shift;
        const position = shift.position;

        return (
            <div>
                <div className="report-box">
                    <div className="report-left">
                        <div className="report-item">
                            <h3 className="section-title">Total cost</h3>
                            <div className="report-number">{DJ_CONST.LOCALE_CONF.currency} {this.state.totalCost.toFixed(2)}</div>
                        </div>
                        <div className="report-item">
                            <h3 className="section-title">Workers</h3>
                            <div className="report-number">{candidates.length}</div>
                        </div>
                        <div className="report-item report-item-fee">
                            <h3 className="section-title">Our fee</h3>
                            <div className="report-number">{DJ_CONST.LOCALE_CONF.currency} {this.state.ourFee}</div>
                        </div>
                        <div className="report-item report-item-total">
                            <span>{DJ_CONST.LOCALE_CONF.currency}{ DJ_CONST.OUR_FEE_COEFFICENT } per candidate</span>
                        </div>
                    </div>
                </div>
                <div className="table-wrapper">
                    <div className="table worker-table">
                        <div className="table-header">
                            <div className="align-left">WORKER</div>
                            <div>STATUS</div>
                            <div>HOURLY RATE</div>
                            <div>HOURS</div>
                            <div>COST</div>
                        </div>
                        {this.getCandidates(candidates, getShiftDuration(shift))}
                    </div>
                </div>

                <div className="info-container">
                    <span className="info">You can edit the actual worked hours.</span>
                </div>

                <div className="buttons">
                    <button onClick={this.saveState.bind(this, shift.id, 'save')} className="btn btn-small btn-gray ">Save</button>
                    <button onClick={this.saveState.bind(this, shift.id, 'confirm')} className="btn btn-small btn-green">Confirm</button>
                </div>
            </div>
        );
    }

    render () {
        return (
            <div className={"finish-shift-step-content finish-shift-step2 " + this.props.className}>
                {this.props.candidates != null ? this.getContent() : <LoadingView />}
            </div>
        );
    }
}

export default FinishShiftStep2;



/** WEBPACK FOOTER **
 ** ./app/src/components/FinishShiftStep2.js
 **/